import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parseImageUrl from "@insite/mobius/utilities/parseImageUrl";
import CENHomeArrowRightFirst from "@tCentro/Icons/CENHomeArrowRightFirst";
import CENHomeArrowRightSecond from "@tCentro/Icons/CENHomeArrowRightSecond";
import CENHomeCardCheck from "@tCentro/Icons/CENHomeCardCheck";
import parse from "html-react-parser";
import { connect, ResolveThunks } from "react-redux";

import LazyImage from "@insite/mobius/LazyImage";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    background = "background",
    desktop_image = "desktop_image",
    tablet_image = "tablet_image",
    mobile_image = "mobile_image",
    smallImage = "smallImage",
    backgroundColor = "backgroundColor",
    heading = "heading",
    buttonLabelOne = "buttonLabelOne",
    buttonOneLink = "buttonOneLink",
    buttonLabelTwo = "buttonLabelTwo",
    buttonTwoLink = "buttonTwoLink",
    text = "text",
    backgroundImage = "backgroundImage",
    buttonOneBackgroundColor = "buttonOneBackgroundColor",
    buttonOneOpacity = "buttonOneOpacity",
    buttonOneColor = "buttonOneColor",
    mainHeadingColor = "mainHeadingColor",
}

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: state.context?.session?.isAuthenticated && !state.context?.session?.isGuest,
});
interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.desktop_image]: string;
        [fields.tablet_image]: string;
        [fields.mobile_image]: string;
        [fields.smallImage]: string;
        [fields.heading]: string;
        [fields.buttonLabelOne]: string;
        [fields.buttonOneBackgroundColor]: string;
        [fields.buttonOneColor]: string;
        [fields.buttonLabelTwo]: string;
        [fields.text]: string;
        [fields.backgroundImage]: string;
        [fields.backgroundColor]: string;
        [fields.buttonOneLink]: LinkFieldValue;
        [fields.buttonTwoLink]: LinkFieldValue;
        [fields.mainHeadingColor]: string;
        [fields.buttonOneOpacity]: string;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface HomePageBannerNewStyles {
    signInCreateNewAccountContainer?: InjectableCss;
    checkIconStyles?: IconPresentationProps;
    cardSecondPart: InjectableCss;
    mapOuter: InjectableCss;
    mapInner: InjectableCss;
    buttonDiv: InjectableCss;
    imageWrapper: InjectableCss;
}

export const homePageBannerNewStyles: HomePageBannerNewStyles = {
    imageWrapper: {
        css: css`
            div[class^="LazyImageStyle"] {
                max-width: 296px;
                max-height: 200px;
                width: 100%;
            }
            @media all and (min-width: 895px) and (max-width: 992px) {
                width: 35% !important;
                display: flex !important;
                justify-content: flex-end !important;
            }
            @media all and (max-width: 1024px) {
                margin-left: 0px !important;
            }

            @media all and (min-width: 1500px) and (max-width: 1710px) {
                width: 36.5% !important;
                display: flex !important;
                justify-content: flex-end !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        img {
                            max-width: 180px;
                            max-height: 121.57px;
                            object-fit: cover;
                        }
                    `,
                    css`
                        img {
                            max-width: 180px;
                            max-height: 121.57px;
                            object-fit: cover;
                        }
                    `,
                    css`
                        width: 25%;
                        display: flex;
                        justify-content: flex-end;
                        margin-top: 23.22px;
                        margin-bottom: 23.22px;
                        img {
                            max-width: 180px;
                            max-height: 121.57px;
                            object-fit: cover;
                        }
                    `,
                    css`
                        width: 22%;
                        display: flex;
                        justify-content: flex-end;
                        margin-left: 65.87px;
                    `,
                    css`
                        width: 37.4%;
                        display: flex;
                        justify-content: flex-end;
                    `,
                ])}
        `,
    },
    cardSecondPart: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    mapOuter: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    mapInner: {
        css: css`
            display: flex;
        `,
    },

    buttonDiv: {
        css: css`
            display: flex;
            align-items: flex-start;
            gap: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 8px;
                        justify-content: center;
                    `,
                    css`
                        gap: 8px;
                        justify-content: center;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
            a {
                text-decoration: none;
            }
        `,
    },
};
const styles = homePageBannerNewStyles;

const CENHomePageBannerNew: FC<Props> = ({ fields }) => {
    const backgroundStyles =
        fields.background === "image"
            ? `background-image: url(${parseImageUrl(fields.desktop_image).url}) !important;
           background-size: cover;
           max-width: 1800px;
        //    max-height:200px;
        //    aspect-ratio : 679/180;
           margin:auto;
           background-repeat:no-repeat;
           `
            : `background-color: ${fields.backgroundColor};`;

    const container = {
        css: css`
            ${backgroundStyles};
            width: 100%;
            display: flex;
            padding: 40px 64px 40px 64px;
            align-items: center;
            gap: 60px;
            justify-content: start;            
            border-bottom: 1px solid ${getColor("common.border")};
            @media all and (min-width: 992px) and (max-width: 1024px) {
                margin-top: 42px !important;
                padding: 40px 16px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 40px 16px;
                        flex-direction: column;
                        gap: 16px;
                        max-height: 100%;
                        background-image: url(${parseImageUrl(fields.mobile_image).url}) !important;
                        aspect-ratio: 25/24;
                    `,
                    css`
                        padding: 40px 16px;
                        flex-direction: column;
                        gap: 16px;
                        max-height: 100%;
                        background-image: url(${parseImageUrl(fields.mobile_image).url}) !important;
                        aspect-ratio: 25/24;
                    `,
                    css`
                        padding: 40px 16px;
                        margin-top: 52px;
                        gap: 16px;
                        max-height: 100%;
                        max-height: 248px;
                        background-image: url(${parseImageUrl(fields.tablet_image).url}) !important;
                        aspect-ratio: 96/41;
                    `,
                    null,
                    null,
                ])}
        `,
    };

    const mainHeading = {
        css: css`
            width: 59.88%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 24px;
            @media all and (max-width: 1024px) {
                max-height: none !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        gap: 24px;
                        max-height: none;
                    `,
                    css`
                        width: 100%;
                        gap: 24px;
                        max-height: none;
                    `,
                    css`
                        width: 70%;
                        gap: 24px;
                    `,
                    css``,
                    css`
                        width: 100%;
                        max-width: 1024px;
                    `,
                ])}

            h1 {
                font-family: "Roboto Condensed";
                font-weight: 600;
                font-size: 56px;
                line-height: 64px;
                color: ${fields.mainHeadingColor};
                margin-bottom: 0px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                            text-align: center;
                        `,
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                            text-align: center;
                        `,
                        css`
                            font-weight: 600;
                            font-size: 40px;
                            line-height: 48px;
                        `,
                        css``,
                        css``,
                    ])}
            }
        `,
    };

    const buttonOne = {
        css: css`
            background-color: ${fields.buttonOneBackgroundColor};
            color: ${fields.buttonOneColor};
            border: none;
            border-radius: 4px;
            font-family: "Poppins";
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
            padding: 12px 16px 12px 16px;
            gap: 8px;
            display: flex;
            align-items: center;
            min-height: 48px;
            min-width:159px;
            span {
                font-family: Roboto Condensed !important;
                font-weight: 700 !important;
                font-size: 18px !important;
                width:100%;
            }
            &:hover {
                background-color: ${fields.buttonOneBackgroundColor};
                color: ${fields.buttonOneColor};
                border: none;
                opacity: ${fields.buttonOneOpacity};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-height: 32px;
                        border-radius: 4px;
                        padding: 12px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 18px !important;
                    `,
                    css`
                        min-height: 32px;
                        border-radius: 4px;
                        padding: 12px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 18px !important;
                    `,
                    css`
                        min-height: 32px;
                        border-radius: 4px;
                        padding: 12px 16px;
                        gap: 4px;
                        font-size: 14px;
                        line-height: 18px !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    };
    const iconOne = {
        size: 24,
        css: css`
            svg {
                > path {
                    fill: ${fields.buttonOneColor};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 8px;
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        gap: 8px;
                        width: 16px;
                        height: 16px;
                    `,
                    css`
                        width: 16px;
                        height: 16px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    };

    const { isInShell } = useShellContext();
    const history = useHistory();

    const { url: buttonOneUrl, title: buttonOneTitle } = useGetLink(fields.buttonOneLink);
    const onClickButtonOne = () => {
        if (!buttonOneUrl) {
            return;
        }

        if (buttonOneUrl.startsWith("http")) {
            if (isInShell) {
                return;
            }
            window.location.href = buttonOneUrl;
        } else {
            history.push(buttonOneUrl);
        }
    };

    return (
        <StyledWrapper {...container}>
            <StyledWrapper {...styles.imageWrapper}>
                <LazyImage src={fields.smallImage} altText={fields.heading} />
            </StyledWrapper>
            <StyledWrapper {...mainHeading}>
                <Typography variant="h1">{fields.heading}</Typography>
                <StyledWrapper {...styles.buttonDiv}>
                     <Link href={buttonOneUrl}>
                        <StyledWrapper {...buttonOne}>
                            <span>{fields.buttonLabelOne}</span>
                        </StyledWrapper>
                    </Link>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(CENHomePageBannerNew),
    definition: {
        group: "Common",
        displayName: "NISHomePageBannerNew",
        fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
                hideEmptyOption: true,
            },
            {
                fieldType: "Contextual",
                name: fields.desktop_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Desktop_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.tablet_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Tablet_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.mobile_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Mobile_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
            },
            {
                fieldType: "Contextual",
                name: fields.smallImage,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Banner Small Image",
            },
            {
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Heading",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.mainHeadingColor,
                editorTemplate: "ColorPickerField",
                displayName: "Main Heading Color",
                defaultValue: "#ffffff",
                fieldType: "General",
            },
            {
                name: fields.buttonLabelOne,
                editorTemplate: "TextField",
                displayName: "Button Label One",
                defaultValue: "",
                fieldType: "General",
            },
            {
                fieldType: "Contextual",
                name: fields.buttonOneLink,
                displayName: "Button One Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.buttonOneBackgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Button One Background Color",
                defaultValue: "#ffffff",
                fieldType: "General",
            },
            {
                name: fields.buttonOneOpacity,
                editorTemplate: "TextField",
                displayName: "Button One Opacity",
                defaultValue: "0.7",
                fieldType: "General",
            },
            {
                name: fields.buttonOneColor,
                editorTemplate: "ColorPickerField",
                displayName: "Button One Color",
                defaultValue: "#8f0446",
                fieldType: "General",
            },
        ],
    },
};
export default widgetModule;
